export default "__VITE_ASSET__2b34de1d__"